<template>
    <Page header="Клиенты" type="" :nopadding="false" header_pos="left">
        <template #body>
            <div v-if="!loading && list" class="flex flex-row justify-content-start gap-3 mb-3">
                <AddClient />
                <Button label="Обновить" icon="pi pi-refresh" @click="LoadClients" :loading="loading" class="flex" severity="secondary" size="small"/>
            </div>
            <div v-if="!loading && list" class="flex">
                <ClientsList 
                    :clients="list" 
                    :totalRecords="totalRecords"
                    :filters="lazyParams.filters"
                    :loading="loading" 
                    :defaultParams="lazyParams"
                    @filter="setFilter" 
                    @lazyParams="setParams"
                    @updated="LoadClients" />
            </div>
            <Skeleton v-else width="100%" height="30px" />
        </template>
    </Page>
</template>

<script>
import Connect from '@/assets/js/connect.js'
import Helper from '@/assets/js/helper.js'
import ClientsList from '@/components/personal/client_list.vue'
import AddClient from '@/components/personal/add_client.vue'
import Page from '@/components/public/page.vue'

export default {
    data() {
        return {
            loading: false,
            list: null,
            lazyParams: {
                rows: 10,
                first: 0,
                sortField: null,
                sortOrder: null,
                sort: null,
                filters: {},
            },
            filters: {
                id: {value: '', matchMode: 'contains'},
                email: {value: '', matchMode: 'contains'},
                phone: {value: '', matchMode: 'contains'},
            },
            totalRecords: 0,
        }
    },
    components: {
        ClientsList,
        AddClient,
        Page
    },
    methods: {
        showMess(severity, summary, detail) {
            this.$toast.add({ severity: severity, summary: summary, detail: detail, life: 3000 });
        },
        setFilter(filters) {
            this.lazyParams.filters = filters
            this.LoadClients()
        },
        setParams(params) {
            this.lazyParams = params
            this.LoadClients()
        },
        onPage(event) {
            this.lazyParams = event
        },
        async LoadClients() {
            this.loading = true
            window.scrollTo({ top: 0, behavior: 'smooth' })
            const account_data = await this.connect.GetPersonalClients(this.lazyParams.rows, this.lazyParams.first, this.lazyParams.filters, {}).then(res=>res)
            if(account_data.result) {
                this.list = account_data.data
                this.totalRecords = account_data.total
            } else {
                this.list = []
                this.totalRecords = 0
                this.showMess('error', 'Ошибка', 'Ошибка при загрузке клиентов')
            }
            this.loading = false
        },
    },
    async beforeCreate(){
        this.connect = new Connect()
        this.helper = new Helper()
    },
    async mounted() {
        this.lazyParams.filters = this.filters
        this.LoadClients()
    },
}
</script>